//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').directive('sessionDateRangePicker', [
    '$parse',
    '$rootScope',
    'SessionDateService',
    function(
            $parse,
            $rootScope,
            SessionDateService,
        ) {
      return {
        restrict: 'A',
        require: ['cuDateRangePicker'],
        link(scope, element, attrs, [dateRangePickerCtrl]) {
          const supportedSessionAliases = ['last7Days', 'last30Days', 'last3Months', 'allTime', 'custom'];
          const customOnChangeExpr = attrs.onChange;

          dateRangePickerCtrl.value = readDateFromSession();

          dateRangePickerCtrl.aliases = dateRangePickerCtrl.aliases || supportedSessionAliases;

                    // Override the onChange handler with a sane default for supported session dates
          dateRangePickerCtrl.onChange = function({ cuValue }) {
            if (supportedSessionAliases.indexOf(cuValue.alias) !== -1) {
              SessionDateService.setDateRange(cuValue);
            }

                        // Call custom onChange logic
            $parse(customOnChangeExpr)(scope, { cuValue });
          };

          $rootScope.$watchGroup([
            () => readDateFromSession().startDate.toString(),
            () => readDateFromSession().endDate.toString(),
          ], () => {
            dateRangePickerCtrl.value = readDateFromSession();
          });

          function readDateFromSession() {
            const sessionDate = crl8.session.dateRange;

            return {
              alias: SessionDateService.sessionDateTypeToDateType[sessionDate.type],
              startDate: new Date(sessionDate.from),
              endDate: new Date(sessionDate.to),
            };
          }
        },
      };
    },
  ]);
})();
